<template>
  <div
    class="d-flex-column justify-start align-start gap-18"
    v-if="packOptions?.length > 0"
  >
    <div
      class="d-flex-row solo_duoq_picker_mini left b-radius-9 space-between"
      :class="[isDuoOptionSelected && 'right', !isDuoOptionSelected && 'left']"
    >
      <Tooltip
        :text="$t('solo_option')"
        position="bottom"
        style="width: 100%; z-index: 100"
        class="hide_tip_mobile"
      >
        <div
          class="server_btn b-radius-9 d-flex-row"
          role="button"
          @click="selectOption('solo')"
        >
          <UserIcon />
          <label class="t-white regular-l font-family-2 f-w-500">Solo</label>
        </div>
      </Tooltip>

      <Tooltip
        :text="$t('duo_option')"
        position="bottom"
        style="width: 100%; z-index: 100"
        class="hide_tip_mobile"
      >
        <div
          class="server_btn b-radius-9 d-flex-row"
          role="button"
          v-for="option in packOptions"
          @click="selectOption('duo')"
        >
          <MultiUsers />
          <label class="t-white regular-l font-family-2 f-w-500">Duo</label>
        </div>
      </Tooltip>
    </div>
  </div>
</template>

<script setup>
import UserIcon from "~/components/icons/UserIcon.vue";
import MultiUsers from "~/components/icons/MultiUsers.vue";
import Tooltip from "~/components/custom/Tooltip.vue";
import { calculateCurrency } from "~/calculate/calculatePrice";

const { getGame, getGamePack } = useGameStore();
const { getUserCurrency } = useUserStore();
const checkoutStore = useCheckoutStore();

const packOptions = computed(() => {
  const gamePackOptions =
    getGamePack.pack_options?.filter(
      (packOp) => packOp?.const_title === "self_play" && !packOp?.slug
    ) || [];
  let parsedGameOptions = [];

  return gamePackOptions;
});

const isDuoOptionSelected = computed(() => {
  const option = packOptions.value[0];
  const selectedOption = checkoutStore.getPackOptions.find(
    (op) => op === option?.id
  );
  if (!selectedOption) {
    return false;
  }
  return true;
});

const selectOption = (type) => {
  const option = packOptions.value[0];
  if (type === "duo") {
    checkoutStore.removePackOption({
      optionIds: option?.rules?.disable || [],
    });

    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id],
    });
  } else if (type === "solo") {
    const otherOptions = checkoutStore.getPackOptions.filter(
      (packOpt) => packOpt !== option.id
    );

    checkoutStore.setPackOptions({
      options: [...otherOptions],
    });
  }
  // if (!isOptionSelected(option.id)) {

  // }
};
</script>

<style lang="scss">
.solo_duoq_picker_mini {
  background-color: var(--bg-medium);
  padding: 6px 6px;
  position: relative;
  .server_btn {
    min-height: 35px;
    cursor: pointer;
    & > * {
      cursor: pointer;
    }
    &.active {
      background-color: var(--blue-opace);
      border: 1px solid var(--blue);
    }
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 45%;
    left: 0%;
    transform: translate(6px, -50%);
    min-height: 35px;
    background-color: var(--blue-opace);
    border: 1px solid var(--blue);
    border-radius: 9px;
    opacity: 0;
    transition: all 0.2s ease-in-out;
    z-index: 19;
  }
  &.left {
    &::after {
      left: 0%;
      opacity: 1;
    }
  }
  &.right {
    &::after {
      opacity: 1;
      left: 50%;
    }
  }
}
</style>
